
/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Drawer from '@mui/material/Drawer';
import UserInfo from 'components/UserInfo';
import { COLLAPSED_DRAWER, FIXED_DRAWER } from 'modules/cbre-flow-Common/constants/ActionTypes';
import { toggleCollapsedNav, updateWindowWidth } from 'modules/cbre-flow-Common/actions/Setting';
import SideBarContent from './SideBarContent';
import { getUserAccess } from 'modules/cbre-flow-api-ducks/selectors';

const SideBar = (props) => {
  const dispatch = useDispatch();
  const { drawerType, width, navigationStyle } = useSelector(({ settings }) => settings);
  const { hasCurrentViewAccess } = useSelector(getUserAccess)
  const [navCollapsed, setNavCollapsed] = useState(false);
  const { isNavCollapsed } = props;

  /*  useEffect(() => {
    window.addEventListener('resize', () => {
      dispatch(updateWindowWidth(window.innerWidth))
    });
  }, [dispatch]); */

  const onToggleCollapsedNav = (e) => {
    const val = !navCollapsed;
    dispatch(toggleCollapsedNav(val));
    // setNavCollapsed(!navCollapsed);
  };

  const drawerStyle = drawerType.includes(FIXED_DRAWER) ? 'd-xl-flex' : (drawerType.includes(COLLAPSED_DRAWER) ? '' : 'd-flex');
  let type = 'permanent';
  if (drawerType.includes(COLLAPSED_DRAWER) || (drawerType.includes(FIXED_DRAWER) && window.innerWidth < 1200)) {
    type = 'temporary';
  }

  if(!hasCurrentViewAccess) {
    return null;
  }

  return (
    <div className={`app-sidebar d-none ${drawerStyle}`}>
      <Drawer
        className="app-sidebar-content"
        variant={type}
        open={type.includes('temporary') ? isNavCollapsed : true}
        onClose={onToggleCollapsedNav}
        classes={{
          paper: 'side-nav top-49',
        }}
      >
        {/* <UserInfo/> */}
        <SideBarContent />
      </Drawer>
    </div>
  );
};

export default withRouter(SideBar);
